import { combineReducers } from 'redux'
import { combineActions } from 'redux-actions'
import injectReducer from '../../state/hoc/injectReducer'

import {
  createRequestingReducer,
  createErrorReducer,
  createSuccessReducer
} from '../../utils/reducer'
import * as actions from './actions'
import { loginRoutine } from './routines'

export const REDUCER_KEY = 'login'

export const requesting = createRequestingReducer(
  loginRoutine.REQUEST,
  loginRoutine.FULFILL
)

export const error = createErrorReducer(
  loginRoutine.FAILURE,
  actions.SET_TOKEN
)

export const tokenCleanUpActions = combineActions(
  loginRoutine.FAILURE,
  actions.LOGOUT,
  actions.ON_TOKEN_EXPIRED
)

export const token = createSuccessReducer(
  actions.SET_TOKEN,
  tokenCleanUpActions,
  null
)

const reducer = combineReducers({
  requesting,
  error,
  token
})

export const withReducer = injectReducer({ key: REDUCER_KEY, reducer })

export default reducer
